import { Sparkles, Zap } from "lucide-react";

export default function V1_0_0() {
  return (
    <div className="tw-space-y-6">

      <div>
        <h3 className="tw-flex tw-items-center tw-gap-2 tw-text-lg tw-font-semibold tw-text-gray-800 tw-mb-3">
          <Sparkles size={20} className="tw-text-yellow-500" />
          Nouvelles fonctionnalités
        </h3>
        <ul className="tw-list-disc tw-pl-8 tw-space-y-2 tw-text-gray-700">
          <li>
            <strong>Vérification du délai de carence</strong> — Lors de l'analyse d'un devis,
            le système vérifie automatiquement si le délai de carence est respecté.
            Une confirmation est demandée si vous souhaitez tout de même accorder la prise en charge.
          </li>
          <li>
            <strong>Montants internes (pilotage)</strong> — Possibilité de saisir les coûts internes
            (montant couvert, geste commercial) lors d'une prise en charge directe,
            pour un meilleur suivi financier.
          </li>
          <li>
            <strong>Historique des anciens SAV</strong> — Visualisez les précédents SAV d'un bénéficiaire
            avec le détail des décisions (accord, partiel, refus) et les montants associés.
            Cet historique est aussi visible côté garant lors de la validation.
          </li>
          <li>
            <strong>Modification de l'email du bénéficiaire</strong> — Vous pouvez désormais corriger
            l'email du bénéficiaire directement depuis la fiche SAV ou lors de l'envoi
            pour signature, sans avoir à quitter le dossier.
          </li>
          <li>
            <strong>Vérification des signataires</strong> — Avant l'envoi pour signature électronique,
            les informations des signataires (garant et bénéficiaire) sont vérifiées automatiquement.
            L'envoi est bloqué si des informations sont manquantes ou invalides.
          </li>
          <li>
            <strong>Alerte contrat inactif</strong> — Un message d'alerte s'affiche automatiquement
            à l'ouverture d'un SAV si le contrat associé est expiré ou annulé.
          </li>
          <li>
            <strong>Notes de version</strong> — Cette page ! Retrouvez ici le détail
            des nouveautés à chaque mise à jour.
          </li>
          <li>
            <strong>Signature électronique avec Smart Anchors</strong> — Le positionnement
            des champs de signature dans les bons pour accord est désormais automatique
            grâce aux Smart Anchors Yousign. La signature et la date de signature sont
            centrées dans les zones prévues, et la page blanche en fin de document a été supprimée.
          </li>
        </ul>
      </div>

      <div>
        <h3 className="tw-flex tw-items-center tw-gap-2 tw-text-lg tw-font-semibold tw-text-gray-800 tw-mb-3">
          <Zap size={20} className="tw-text-blue-500" />
          Améliorations
        </h3>
        <ul className="tw-list-disc tw-pl-8 tw-space-y-2 tw-text-gray-700">
          <li>
            <strong>Liste des contrats</strong> — Ajout d'une colonne statut (actif, expiré, annulé)
            avec badges colorés, et d'un panneau de filtres par statut.
          </li>
          <li>
            <strong>Badge anciens SAV</strong> — Le bouton « Historique » affiche désormais
            un compteur indiquant le nombre d'anciens SAV du bénéficiaire.
          </li>
        </ul>
      </div>

    </div>
  );
}
